export const visit = (vm, at) => {
vm(require("foundations-components/lang/tr.lyaml"));
at({ "tr": { "placeholder": "yer tutucu" } });
};